<template>
    <div>
        <app-header></app-header>
        <router-view></router-view>
        <app-footer></app-footer>        
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Profile',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/Profile.vue